import useWidth from '@components/Hooks/useWidth';
import { MIN_SCREEN_HEADER_HEIGHT } from '@components/v2/constants';
import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { ScreenHeaderActions } from './components/ScreenHeaderActions/ScreenHeaderActions';
import { ScreenHeaderContent } from './components/ScreenHeaderContent';
import { ScreenHeaderTitle } from './components/ScreenHeaderTitle';
import { ScreenHeaderPrimaryAction, ScreenHeaderTagConfig } from './screenHeader.types';

interface ScreenHeaderProps {
  breadcrumb: ReactNode;
  tags?: ScreenHeaderTagConfig[];
  navigator?: ReactNode;
  actions?: ReactNode;
  trailing?: ReactNode;
  primaryAction?: ScreenHeaderPrimaryAction;
}

export const ScreenHeader = ({
  breadcrumb,
  tags,
  navigator,
  actions,
  trailing,
  primaryAction,
}: ScreenHeaderProps) => {
  const { isCustomizedTabletDown, mobileWidth } = useWidth();
  const { padding: workspacePadding } = useWorkspacePadding();

  return (
    <Box
      sx={{
        mx: -workspacePadding,
        borderBottom: 1,
        borderColor: (theme) => theme.palette.custom.border.secondary,
        minHeight: MIN_SCREEN_HEADER_HEIGHT,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: 1,
          pl: isCustomizedTabletDown ? 1 : 2,
          pr: 1,
          py: 1,
          width: '100%',
        }}
      >
        {isCustomizedTabletDown ? (
          <ScreenHeaderTitle breadcrumb={breadcrumb} tags={tags} isPhone={mobileWidth} />
        ) : (
          <ScreenHeaderContent breadcrumb={breadcrumb} tags={tags} trailing={trailing} />
        )}
        {!isCustomizedTabletDown && navigator}
        <ScreenHeaderActions
          actions={actions}
          primaryAction={primaryAction}
          isPhone={mobileWidth}
        />
      </Stack>
    </Box>
  );
};
